import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface ServiceCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  link: string;
  image?: string;
  className?: string;
}

const ServiceCard = ({ title, description, icon, link, image, className }: ServiceCardProps) => {
  return (
    <Link
      to={link}
      className={cn(
        "group relative overflow-hidden rounded-2xl border border-border/30 transition-all duration-300 hover:-translate-y-1 hover:border-secondary/50 hover:shadow-[0_0_30px_hsl(var(--primary)/0.2)]",
        className
      )}
    >
      {/* Background Image */}
      {image && (
        <div 
          className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110 pointer-events-none"
          style={{ backgroundImage: `url(${image})` }}
        />
      )}
      
      {/* Gradient Overlay - dark overlay for image visibility */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/85 to-black/60 pointer-events-none" />
      
      {/* Content */}
      <div className="relative z-10 p-6 h-full flex flex-col min-h-[260px]">
        <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-secondary/40 to-primary/40 backdrop-blur-sm flex items-center justify-center mb-4 group-hover:from-secondary/50 group-hover:to-primary/50 transition-all border border-primary/30">
          {icon}
        </div>
        <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-secondary transition-colors">
          {title}
        </h3>
        <p className="text-white/80 text-sm mb-4 leading-relaxed flex-grow">{description}</p>
        <div className="flex items-center gap-2 text-secondary text-sm font-medium mt-auto">
          En savoir plus
          <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;
